<template>
  <div v-if="visible" class="reauth-overlay d-flex align-items-center justify-content-center">
    <div class="reauth-modal card glassy shadow-xl">
      <div class="card-body p-2 p-sm-3 p-md-4">
        <div class="d-flex align-items-center mb-2">
          <div class="reauth-icon mr-2 d-flex align-items-center justify-content-center">
            <feather-icon icon="LockIcon" size="20" />
          </div>
          <div>
            <h4 class="mb-0">Sessão expirada</h4>
            <small class="text-muted">Faça login para continuar onde parou.</small>
          </div>
        </div>

        <LoginForm :suppressRedirect="true" @success="onSuccess" />

        <div class="text-center mt-1">
          <b-button size="sm" variant="link" class="text-muted" @click="onCancel">Cancelar</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { BButton } from 'bootstrap-vue'
import LoginForm from '@/components/auth/LoginForm.vue'

export default {
  name: 'LoginReauthModal',
  components: { LoginForm, BButton },
  computed: {
    ...mapState('authUi', ['loginModalOpen']),
    visible() {
      return this.loginModalOpen
    },
  },
  methods: {
    ...mapActions('authUi', ['resolveLoginModal', 'rejectLoginModal']),
    onSuccess() {
      this.resolveLoginModal()
    },
    onCancel() {
      this.rejectLoginModal()
    },
  },
}
</script>

<style lang="scss" scoped>
.reauth-overlay {
  position: fixed;
  inset: 0;
  background: rgba(8, 10, 20, .50);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 1060; /* acima de loaders/headers */
  padding: 1rem;
}

.reauth-modal.glassy {
  width: 100%;
  max-width: 460px;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(108, 117, 125, 0.2);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.92) 0%,
    rgba(255, 255, 255, 0.96) 100%
  );
}

.reauth-icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7367F0 0%, #9E95F5 100%);
  color: #fff;
  flex: 0 0 auto;
  box-shadow: 0 6px 18px rgba(115, 103, 240, .35);
}

/* Dark mode */
body.dark-layout {
  .reauth-modal.glassy {
    background: linear-gradient(
      180deg,
      rgba(40, 48, 70, 0.90) 0%,
      rgba(40, 48, 70, 0.95) 100%
    );
    border-color: rgba(255, 255, 255, 0.08);
    color: #d0d2d6;
  }
}
</style>
